import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "mr-2 capitalize inline font-medium truncate" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-chevron-down ml-2 text-base" }, null, -1);
const _hoisted_3 = { class: "origin-top-right absolute shadow-lg cursor-pointer bg-gray-100 z-50 mt-1" };
const _hoisted_4 = {
    class: "overflow-y-auto",
    style: { "max-height": "50vh", "max-width": "90vw" }
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
    key: 1,
    class: "flex items-center p-2"
};
const _hoisted_7 = { class: "mr-2 capitalize inline font-medium truncate" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_avatar = _resolveComponent("avatar");
    return (_ctx.personalWorkspaces && _ctx.personalWorkspaces.length >= 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "workSpaceDropdown",
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.dropDownOpen = !_ctx.dropDownOpen)),
            class: "truncate"
        }, [
            _createElementVNode("div", {
                class: _normalizeClass(["flex items-center p-2 cursor-pointer", {
                        'hover:bg-gray-100': _ctx.personalWorkspaces,
                        'cursor-pointer': _ctx.personalWorkspaces,
                        'bg-gray-100': _ctx.dropDownOpen,
                    }])
            }, [
                _renderSlot(_ctx.$slots, "selectedItem", {}, () => [
                    _createVNode(_component_avatar, {
                        class: "mr-5 h-8 w-8",
                        "round-size": "full",
                        src: `https://picsum.photos/seed/${_ctx.selectedVaultId}/300/300`
                    }, null, 8, ["src"]),
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.selectedVaultName), 1)
                ]),
                _hoisted_2
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalWorkspaces, (personalSpace) => {
                        return (_openBlock(), _createElementBlock("a", {
                            onClick: ($event) => (_ctx.openWorkSpace(personalSpace)),
                            key: personalSpace.id,
                            class: "block px-4 py-2 text-sm text-primary hover:bg-gray-200 font-medium hover:text-gray-900 truncate"
                        }, _toDisplayString(personalSpace.name), 9, _hoisted_5));
                    }), 128))
                ])
            ], 512), [
                [_vShow, _ctx.dropDownOpen && _ctx.personalWorkspaces.length >= 1]
            ])
        ], 512))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_avatar, {
                class: "mr-5 h-8 w-8",
                "round-size": "full",
                src: `https://picsum.photos/seed/${_ctx.selectedVaultId}/300/300`
            }, null, 8, ["src"]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.selectedVaultName), 1)
        ]));
}
